export default __webpack_public_path__ + "static/media/q19_03.7a769764.png";